<!--
* @description  参数1
* @fileName  detailEdit
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
  <div id="detailEdit" class="detailEdit">
    <DialogEidt :value="isShow" @close="closeDialog">
      <template v-slot:title>
        <div>公司信息</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form
            ref="formData"
            :model="formData"
            :rules="allRules"
            label-position="top"
            size="medium"
            class="item-Surcharge"
            @submit.native.prevent
          >
            <div class="new_inquiry_header item-Surcharge_search">
              <el-form-item class="flex-width_1" prop="customerName" label="公司名称">
                <el-input v-model="formData.customerName" disabled />
              </el-form-item>
              <el-form-item
                class="flex-width_1"
                prop="monthlyInternational"
                label="每月发货频率"
              >
                <el-select
                  v-model="formData.monthlyInternational"
                  :popper-append-to-body="false"
                  style="text-align: left;width: 100%;"
                >
                  <el-option
                    v-for="item in monthlyInternationalOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  />
                </el-select>
              </el-form-item>
              <el-form-item class="flex-width_1" prop="countryId" label="所在国家">
                <el-select
                  v-model="formData.countryId"
                  filterable
                  :popper-append-to-body="false"
                  style="text-align: left;width: 100%;"
                >
                  <el-option
                    v-for="(item, index) in countryList"
                    :key="index"
                    :value="item.id"
                    :label="item.code+'-'+item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item class="flex-width_1" prop="cityName" label="所在城市">
                <el-input v-model="formData.cityName" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">取消</button>
          <button class="save by-button--primary" :loading="btnLoading" @click="clickSave">保存</button>
        </div>
      </template>
    </DialogEidt>
  </div>
</template>

<script>
import {
  GetCountry
} from '../../../api/base.js'
import {
  GetCurrCustomer,
  UpdateCustomerDetail
} from '../../../api/user.js'
import DialogEidt from '../../../components/Dialog/Dialog.vue'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'DetailEdit',
  components: {
    // 组件的引用
    DialogEidt
  },
  props: {
    // 父辈向子辈传参
    isShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      formData: {
        customerName: '',
        monthlyInternational: '',
        countryId: '',
        cityName: ''
      },
      token: '',
      btnLoading: false,
      countryList: [],
      monthlyInternationalOptions: [{
        value: '50+',
        label: '50+'
      },
      {
        value: '10-49',
        label: '10-49'
      },
      {
        value: '2-9',
        label: '2-9'
      },
      {
        value: '少于两次',
        label: '少于两次'
      },
      {
        value: '无',
        label: '无'
      }
      ],
      allRules: {
        customerName: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        },
        {
          pattern: /^.{3,}$/,
          message: 'Company name is required',
          trigger: 'blur'
        }
        ],
        monthlyInternational: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        countryId: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }]
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCountry()
      this.getCurrCustomer()
    }
  },
  methods: {
    getCountry() {
      GetCountry().then(res => {
        this.countryList = res.data
      })
    },
    getCurrCustomer() {
      GetCurrCustomer().then(res => {
        this.formData = res.data
      })
    },
    closeDialog() {
      this.$emit('close', false)
    },
    clickSave() {
      // 表单校验
      this.$refs['formData'].validate((val) => {
        console.log('====校验', val)
        if (val) {
          UpdateCustomerDetail(this.formData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.closeDialog()
                  this.$emit('refresh', true)
                }
              })
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	::v-deep .dialog__header {
		text-align: left;
	}

	::v-deep .dialog__body {
		padding: 0;

		.el-form-item {
			margin-bottom: 0;

			.el-form-item__label {
				float: left;
			}
		}
	}

	::v-deep .el-form-item__error {
		display: block !important;
	}

	.foot-class {
		margin: 24px 0;
		padding-bottom: 24px;
		text-align: right;

		.cancel {
			width: 72px;
			height: 32px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid #dddddd;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-right: 16px;
			cursor: pointer;
		}

		.save {
			width: 72px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
		}
	}
</style>
